/* GDP — preload the first visible cards only as their rail approaches the viewport. */
(function () {
  var RAILS = [
    '.gdp-amd-home__grid',
    '.gdp-assortment-decoder__grid',
    '.m2e-lo__crail',
    '.gdp-aq__flavors',
    '.h1m__grid'
  ];

  function prime(rail) {
    // Explicit server position: leave later home-section images under native lazy loading.
    if (rail.getAttribute('data-gdp-rail-loading') === 'lazy') return;
    var kids = rail.children, done = 0;
    for (var i = 0; i < kids.length && done < 2; i++) {
      var r = kids[i].getBoundingClientRect();
      if (r.width < 40) continue;
      done++;
      var imgs = kids[i].querySelectorAll('img');
      for (var j = 0; j < imgs.length; j++) {
        if (imgs[j].getAttribute('loading') === 'lazy') {
          imgs[j].setAttribute('loading', 'eager');
          imgs[j].setAttribute('fetchpriority', 'low');
          // relance le chargement si le navigateur avait deja tranche
          if (!imgs[j].complete) { var s = imgs[j].getAttribute('src'); if (s) imgs[j].setAttribute('src', s); }
        }
      }
    }
  }

  var nearbyRails = typeof IntersectionObserver === 'function' ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      prime(entry.target);
      nearbyRails.unobserve(entry.target);
    });
  }, { rootMargin: '600px 0px', threshold: 0 }) : null;

  function run() {
    for (var k = 0; k < RAILS.length; k++) {
      var list = document.querySelectorAll(RAILS[k]);
      for (var i = 0; i < list.length; i++) {
        try {
          if (list[i].getAttribute('data-gdp-rail-loading') === 'lazy') continue;
          if (nearbyRails) nearbyRails.observe(list[i]);
          else prime(list[i]);
        } catch (e) { }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
